import $ from 'jquery';
import _ from 'underscore';
import {
    restRequest
} from 'girder/rest';
import View from 'girder/views/View';
import 'girder/utilities/jquery/girderModal';
import events from '../events';
import template from '../templates/dialogs/summaryImage.pug';
import '../stylesheets/body/common.styl';
import '../stylesheets/dialogs/summaryImage.styl';

let dialog;
let summaryInfo = [];
let elementsLength = 0;
let itemId = null;
let imageName = '';
let summaryProcess = false;

const SummaryImage = View.extend({
    render() {
        this.fetchAnnotations();
        return this;
    },
    displayAnnotations() {
        this.$el.html(template({
            summaryInfo,
            elementsLength,
            imageName
        })).girderModal(this);
    },
    fetchAnnotations() {
        if (!summaryProcess) {
            summaryProcess = true;
            restRequest({
                url: `/annotation/item/${itemId}`
            }).then((_annotations) => {
                let annotations = _annotations;
                let details = [];
                let i = 0;
                annotations.forEach(ann => {
                    let elements = ann.annotation.elements;
                    if (elements.length > 0) {
                        // noOfLabels => Total no of labels without grouping them
                        // noOfUniqueLabels => Total no of labels after grouping them by label name/type
                        // labels => List containing all the element label/type
                        // uniqueLabels => List containing element label/type after grouping them by label name/type
                        // percentage => Percentage of unique labels per group to total no of unique labels
                        // labelDetails => List containing type, no.of labels by type and percentage per group
                        details.push({
                            groupName: elements[0].group || 'default',
                            noOfLabels: 0,
                            noOfUniqueLabels: 0,
                            uniqueLabels: [],
                            labels: [],
                            percentage: 0,
                            labelDetails: []
                        });
                        elements.forEach(ele => {
                            details[i].noOfLabels++;
                            elementsLength++;
                            if (ele.label) {
                                if (ele.label.value.includes(':')) {
                                    details[i].labels.push({
                                        type: ele.label.value.split(':')[0].trim()
                                    });
                                } else {
                                    details[i].labels.push({
                                        type: ele.label.value
                                    });
                                }
                            } else {
                                if (ele.type == 'polyline' && ele.closed) {
                                    details[i].labels.push({
                                        type: 'polygon'
                                    });
                                } else if (ele.type == 'polyline' && !ele.closed) {
                                    details[i].labels.push({
                                        type: 'line'
                                    });
                                } else {
                                    details[i].labels.push({
                                        type: ele.type
                                    });
                                }

                            }

                        });
                        i++;
                    }
                });
                var detailsByGroupName = _.groupBy(details, 'groupName');
                Object.keys(detailsByGroupName).forEach(idx => {
                    detailsByGroupName[idx].forEach(d => {
                        detailsByGroupName[idx][0].noOfUniqueLabels = d.noOfLabels + detailsByGroupName[idx][0].noOfUniqueLabels;
                        d.labels.forEach(li => {
                            detailsByGroupName[idx][0].uniqueLabels.push(li);
                        });
                    });
                    summaryInfo.push(detailsByGroupName[idx][0]);
                });
                summaryInfo.forEach(index => {
                    index.percentage = ((index.noOfUniqueLabels / elementsLength) * 100).toFixed(2);
                    var labelsByType = _.groupBy(index.uniqueLabels, 'type');
                    if (labelsByType) {
                        Object.keys(labelsByType).forEach(l => {
                            index.labelDetails.push({
                                type: labelsByType[l][0].type,
                                quantity: labelsByType[l].length,
                                percentage: ((labelsByType[l].length / index.noOfUniqueLabels) * 100).toFixed(2)
                            });
                        });
                    }
                    index.labelDetails.sort((a,b) => {
                        return (a.quantity > b.quantity ? -1 : (a.quantity < b.quantity ? 1 : 0))
                    });
                });
                summaryInfo.sort((a,b) => {
                    return (a.noOfUniqueLabels > b.noOfUniqueLabels ? -1 : (a.noOfUniqueLabels < b.noOfUniqueLabels ? 1 : 0))
                });
                this.displayAnnotations();
            }).done((resp) => {
                summaryProcess = false;
            });
        }
    },

});

function createDialog() {
    return new SummaryImage({
        parentView: null
    });
}

events.on('h:summaryImageUi', (model) => {
    itemId = model.id;
    imageName = model.name();
    summaryInfo = [];
    elementsLength = 0;
    if (!dialog) {
        dialog = createDialog();
    }
    dialog.setElement($('#g-dialog-container')).render();
});

export default createDialog;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/dialogs/summaryImage.js